import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import './LayoutGeneral.css';
import logo from './Imagenes/logo.png';

const LayoutGeneral = ({ titulo, children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem("token");
    const idUsuario = localStorage.getItem('idUsuario');
    // Rutas públicas (sin autenticación)
    const rutasPublicas = ["/", "/reset-password"];
    if ((!token || !idUsuario) && !rutasPublicas.includes(location.pathname)) {
      navigate("/"); // Redirige al login si falta token o idUsuario
    }
}, [navigate, location.pathname]);

  return (
    <div className="layout-general">
      {/* Banner superior */}
      <header className="layout-header">
        <img src={logo} alt="Logo" className="layout-logo" />
        <h1 className="layout-title">{titulo}</h1>
      </header>

      {/* Contenido dinámico, cada pantalla va tener su propio contenido */}
      <main className="layout-content">
        {children}
      </main>

      {/* pie de pagina */}
      <footer className="layout-footer">
        Sistema de comunicación CRM @2025 - versión 1.0 - Usuario: {localStorage.getItem("nombreUsuario")}
      </footer>
    </div>
  );
};

export default LayoutGeneral;
